import React from "react";

const EventConcludedNotice = () => {
  return (
    <div
      className="max-w-4xl mx-auto px-5 py-5 md:px-8 md:py-6 mb-10 md:mb-14 fade-up"
      style={{
        background: "rgba(245, 230, 200, 0.55)",
        border: "1px solid var(--border-soft)",
        boxShadow: "0 18px 40px -28px rgba(140, 100, 50, 0.18)",
      }}
      data-testid="event-concluded-notice"
    >
      <div className="flex flex-col md:flex-row items-center gap-4 md:gap-6 text-center md:text-left">
        <div
          className="flex-shrink-0 w-12 h-12 flex items-center justify-center"
          style={{
            background: "rgba(255,255,255,0.6)",
            border: "1px solid var(--gold-soft)",
            borderRadius: "50%",
          }}
          aria-hidden="true"
        >
          <svg
            width="22"
            height="22"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              cx="12"
              cy="12"
              r="10"
              stroke="var(--gold-deep)"
              strokeWidth="0.8"
              fill="none"
            />
            <path
              d="M12 7 V12 L15 14"
              stroke="var(--gold-deep)"
              strokeWidth="1.1"
              strokeLinecap="round"
              fill="none"
            />
          </svg>
        </div>
        <div>
          <p
            className="eyebrow"
            style={{ fontSize: "0.75rem", letterSpacing: "0.3em" }}
            data-testid="event-concluded-eyebrow"
          >
            Previous Masterclass Concluded
          </p>
          <p
            className="mt-2 font-serif italic"
            style={{
              color: "var(--ink)",
              fontSize: "1.2rem",
              lineHeight: 1.4,
            }}
            data-testid="event-concluded-message"
          >
            "Desire Is The Doorway To Your Freedom" has now finished. Register
            below to save your seat for the next live masterclass on{" "}
            <span style={{ color: "var(--gold-deep)" }}>Wednesday 18th June</span>.
          </p>
        </div>
      </div>
    </div>
  );
};

export default EventConcludedNotice;
